import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['wrapper']
  static values = {
    projectId: String,
    hiddenImageIndex: Number
  }

  connect() {
    console.log('Hidden image controller connected')
  }

  toggle(event) {
    const checkbox = event.target
    const imageIndex = checkbox.dataset.imageIndex
    const isChecked = checkbox.checked

    if (isChecked) {
      // Check if this image is featured
      const radio = this.element.querySelector(`input[type="radio"][data-image-index="${imageIndex}"]`)
      if (radio && radio.checked) {
        alert("Cannot hide a featured image")
        checkbox.checked = false
        return
      }
    }

    this.wrapperTarget.classList.toggle("is-hidden", isChecked)

    this.updateHiddenStatus(imageIndex, isChecked)
  }

  updateHiddenStatus(imageIndex, isHidden) {
    const url = `/campus/student_projects/${this.projectIdValue}/set_hidden_image`
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken,
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        image_index: imageIndex,
        is_hidden: isHidden
      })
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          console.log('Hidden image updated successfully')
        } else {
          console.error('Failed to update hidden image:', data.error)
          alert('Failed to update hidden image: ' + (data.error || 'Unknown error'))
          // Revert checkbox state on error
          this.revertCheckboxes()
        }
      })
      .catch(error => {
        console.error('Error updating hidden image:', error)
        alert('An error occurred while updating the hidden image')
        // Revert checkbox state on error
        this.revertCheckboxes()
      })
  }

  revertCheckboxes() {
    // This would need to restore the previous state
    // For now, just reload the page or refetch the data
    location.reload()
  }
}